import { FunctionComponent } from "react";

import { faExternalLink } from "@fortawesome/pro-regular-svg-icons";

import Checked from "@assets/icons/checked.svg?url";
import Failed from "@assets/icons/failed.svg?url";
import Refresh from "@assets/icons/refresh.svg?url";

import { Icon } from "../Icon/Icon";

export interface WebsiteIconProps {
	status?: "checked" | "failed" | "refresh";
}

export const WebsiteIcon: FunctionComponent<WebsiteIconProps> = ({ status }) => {
	return (
		<div className="relative mr-1 flex h-[20px] w-[20px] items-center justify-center">
			{status === "checked" && (
				<img alt="checked" className="absolute right-[-1px] top-[-1px]" src={Checked} />
			)}
			{status === "failed" && (
				<img alt="failed" className="absolute right-[-1px] top-[-1px]" src={Failed} />
			)}
			{status === "refresh" && (
				<img alt="refresh" className="absolute right-[-1px] top-[-1px]" src={Refresh} />
			)}
			<Icon className="w-[16px] h-[16px] text-text-meta" icon={faExternalLink} />
		</div>
	);
};
